import { EligibilityParentGuardianStudentScreen } from "@/interactors/EligibilityParentGuardianStudentScreen";

export default function ParentGuardianStudent() {
  return <EligibilityParentGuardianStudentScreen />;
}
